/**
 * Trigger download of an array-of-objects as CSV.
 * @param {Object[]} data       Array of objects (all keys should exist on first row)
 * @param {String}   filename   e.g. "export.csv"
 * @param {String}   delimiter  Usually "," or ";" depending on locale
 */
export function downloadCSV<
  T extends Record<string, string | number | boolean | null | undefined>[],
>(data: T, filename = 'export.csv', delimiter = ',') {
  if (!data?.length) {
    console.warn('downloadCSV: data is empty.');
    return;
  }

  const escape = (val: string | number | boolean | null | undefined = '') =>
    `"${String(val).replace(/"/g, '""')}"`;
  const keys = Object.keys(data[0]);

  const csv =
    '\uFEFF' + // UTF-8 BOM
    [
      keys.map(escape).join(delimiter),
      ...data.map((row) => keys.map((k) => escape(row[k])).join(delimiter)),
    ].join('\r\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
